/**
 * How a tab click is named in activity telemetry.
 *
 * Page visits could not say which tabs inside a page earn their keep: tab
 * state lives in component state, never in the URL, so the Sales usage review
 * (docs/design/sales-focus/USAGE-2026-09.md) could rank pages but not the 30
 * tabs inside them. Pure on purpose, like ./areaMatch.
 */

/**
 * The label a tab is recorded under, read from its rendered text because
 * Fluent's Tab does not put its `value` in the DOM.
 *
 * A trailing parenthetical that carries a number is dropped, so live counts
 * and sales-year suffixes ('Broker List (245)', 'Won Cases (2026)') do not
 * split one tab into many rows. A descriptive suffix with no digits, like
 * 'By Broker (New → Existing)', is part of the name and stays.
 */
export function tabLabelFromText(text: string | null | undefined): string {
  const clean = (text ?? '').replace(/\s+/g, ' ').trim();
  return clean.replace(/\s*\([^()]*\d[^()]*\)$/, '').trim().slice(0, 60);
}

/**
 * The area a tab_view row carries: the page it sits on, then the tab. Reads
 * correctly anywhere the activity timeline already shows an area, with no
 * rendering change. Capped to the column's 100 characters.
 */
export function tabViewArea(pageArea: string, tab: string): string {
  return `${pageArea} > ${tab}`.slice(0, 100);
}
